import React, { Component } from "react";
import { Container } from "reactstrap";
import { NavMenu } from "./NavMenu";
import { Footer } from "./Footer";
import { withRouter, RouteComponentProps } from "react-router";

const footerVisibleForRoutes = ["/admin/users", "/user/edit", "/user"];

class LayoutWithRouter extends Component<RouteComponentProps> {
  static displayName = LayoutWithRouter.name;
  location = this.props.location;

  shouldRenderFooter() {
    if (this.location.pathname === "/") {
      return true;
    }
    return footerVisibleForRoutes.some((route) =>
      this.location.pathname.includes(route)
    );
  }

  render() {
    return (
      <>
        <NavMenu />
        <div style={{ flex: "1 0 auto" }}>
          <Container className={"content"}>{this.props.children}</Container>
        </div>
        <Footer visible={this.shouldRenderFooter()} />
      </>
    );
  }
}

export const Layout = withRouter(LayoutWithRouter);
